import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { CheckCircle2, Rocket, Lightbulb, Zap, Download, ShieldCheck } from 'lucide-react';
export function PremiumProduct() {
  const learnings = ['Cómo encontrar proveedores confiables en China sin cometer errores', 'Cómo negociar precios y reducir costos desde el inicio', 'Cómo crear tu nombre de marca y logo profesional', 'Cómo personalizar tu producto para diferenciarte', 'Cómo lanzar una marca que se vea confiable y lista para vender'];
  return <section className="bg-white py-24 px-6" data-id="element-276">
      <div className="max-w-4xl mx-auto" data-id="element-277">
        {/* Header */}
        <FadeIn data-id="element-278">
          <div className="text-center mb-16" data-id="element-279">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-green/10 rounded-full mb-6" data-id="element-280">
              <Rocket className="w-8 h-8 text-brand-green" data-id="element-281" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-green mb-10" data-id="element-282">
              ESTO ES LO QUE SIGUE DESPUÉS DE APRENDER A VENDER
            </h2>

            {/* Product Image */}
            <div className="mb-10 px-4" data-id="element-283">
              <img src="https://cdn.magicpatterns.com/uploads/wkmAtza51kc25BvybjSw4U/portada.png" alt="Crea tu Marca en Amazon desde China - Guía Premium" className="w-full max-w-2xl mx-auto h-auto rounded-2xl shadow-2xl object-contain" data-id="element-284" />
            </div>

            <p className="text-lg md:text-xl text-brand-text/70 leading-relaxed mb-4" data-id="element-285">
              Una vez entiendes cómo funciona Amazon…
            </p>
            <div className="space-y-2 mb-6" data-id="element-286">
              <p className="text-lg md:text-xl text-brand-text font-medium" data-id="element-287">
                Puedes crear tu propio producto.
              </p>
              <p className="text-lg md:text-xl text-brand-text font-medium" data-id="element-288">
                Trabajar con proveedores en China.
              </p>
              <p className="text-lg md:text-xl text-brand-text font-medium" data-id="element-289">
                Y construir una marca que puedas escalar.
              </p>
            </div>

            <p className="text-lg text-brand-text/60 mb-4" data-id="element-290">
              Esto ya no es solo vender.
            </p>
            <p className="text-xl md:text-2xl font-serif text-brand-green font-semibold" data-id="element-291">
              Es construir un negocio real.
            </p>

            <div className="mt-10" data-id="element-292">
              <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/crea-tu-marca-en-amazon-desde-china', '_blank')} className="w-full sm:w-auto text-lg md:text-xl px-14 py-5" data-id="element-293">
                CREAR MI PROPIA MARCA
              </Button>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-4" data-id="element-294">
                <span className="flex items-center gap-1.5" data-id="element-295">
                  <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-296" />
                  ACCESO INMEDIATO
                </span>
                <span className="flex items-center gap-1.5" data-id="element-297">
                  <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-298" />
                  DESCARGA DIGITAL
                </span>
                <span className="flex items-center gap-1.5" data-id="element-299">
                  <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-300" />
                  COMPRA SEGURA
                </span>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Lo que aprenderás */}
        <FadeIn delay={0.1} data-id="element-301">
          <div className="bg-brand-beige rounded-2xl p-8 md:p-10 mb-10" data-id="element-302">
            <div className="flex items-center justify-center gap-3 mb-3" data-id="element-303">
              <Lightbulb className="w-6 h-6 text-brand-gold" data-id="element-304" />
              <h3 className="text-xl md:text-2xl font-bold text-brand-green" data-id="element-305">
                LO QUE VES AQUÍ NO ES SOLO UNA GUÍA
              </h3>
            </div>
            <p className="text-center text-brand-text/60 mb-6" data-id="element-306">
              Es el sistema que te enseña a:
            </p>
            <div className="space-y-4 max-w-xl mx-auto" data-id="element-307">
              <div className="flex items-start gap-3" data-id="element-308">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-309" />
                <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-310">
                  Crear una marca desde cero
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-311">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-312" />
                <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-313">
                  Trabajar con proveedores reales en China
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-314">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-315" />
                <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-316">
                  Diferenciarte de la competencia
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-317">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-318" />
                <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-319">
                  Construir un negocio que pueda crecer
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Lo que aprenderás en la guía premium */}
        <FadeIn delay={0.15} data-id="element-320">
          <div className="bg-brand-beige rounded-2xl p-8 md:p-10" data-id="element-321">
            <div className="flex items-center gap-3 mb-6" data-id="element-322">
              <Rocket className="w-6 h-6 text-brand-gold" data-id="element-323" />
              <h3 className="text-xl md:text-2xl font-bold text-brand-green" data-id="element-324">
                LO QUE APRENDERÁS EN ESTA GUÍA PREMIUM
              </h3>
            </div>
            <div className="space-y-4" data-id="element-325">
              {learnings.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-326">
                  <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-327" />
                  <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-328">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}